@for (img of imgs; track img; let i = $index) {
  <picture>
    <source [srcset]="img + '.avif'" type="image/avif" />
    <source [srcset]="img + '.webp'" type="image/webp" />
    <img
      [src]="img + '.png'"
      class="mx-auto d-block"
      [class.back]="i !== nowDisplayImg"
      alt="intro image"
    />
  </picture>
}
